import React from 'react';
import Icon from '../AppIcon';
import { cn } from '../../utils/cn';

const toneClasses = {
  queued: 'bg-muted/10 text-muted-foreground border-muted/20',
  generating: 'bg-[#2563EB]/10 text-[#2563EB] border-[#2563EB]/20',
  edited: 'bg-primary/10 text-primary border-primary/20',
  scheduled: 'bg-[#7C3AED]/10 text-[#7C3AED] border-[#7C3AED]/20',
  published: 'bg-success/10 text-success border-success/20',
  failed: 'bg-destructive/10 text-destructive border-destructive/20',

  pending: 'bg-muted/10 text-muted-foreground border-muted/20',
  reviewed: 'bg-primary/10 text-primary border-primary/20',
  approved: 'bg-success/10 text-success border-success/20',
  rejected: 'bg-destructive/10 text-destructive border-destructive/20',

  public: 'bg-success/10 text-success border-success/20',
  private: 'bg-muted/10 text-muted-foreground border-muted/20',

  completed: 'bg-success/10 text-success border-success/20',
  locked: 'bg-muted/10 text-muted-foreground border-muted/20',
  in_progress: 'bg-card text-primary border-primary/20',
};

const radiusClasses = {
  md: 'rounded-md',
  full: 'rounded-full',
};

const StatusBadge = ({
  tone = 'queued',
  label,
  iconName,
  rounded = 'md',
  className,
}) => {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 px-3 py-1 text-xs font-medium border caption',
        radiusClasses?.[rounded] || radiusClasses.md,
        toneClasses?.[tone] || toneClasses.queued,
        className
      )}
    >
      {iconName ? <Icon name={iconName} size={14} /> : null}
      <span>{label}</span>
    </span>
  );
};

export default StatusBadge;
